import React from 'react';
import { Select } from 'antd';
import { useState } from 'react';
import PlotContainer from '../PlotContainer';
import { useGetLtvVsCacQuery } from '../../redux/api/customerAnalytics';
import { useSelector } from 'react-redux';
import '../containerStyles.css';
import TooltipContainer from '../../components/UI/TooltipContainer';

const LtvVsCac = () => {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);

    const [filterType, setFilterType] = useState('All');

    return (
      <div className="main-content-container">
        <div className="flexible-container">
          <div>
            <h2>
              Filter By <TooltipContainer title="Filter By"></TooltipContainer>
            </h2>
            <Select
              style={{
                width: "10vw",
              }}
              options={[
                { label: "All", value: "All" },
                { label: "OTP", value: "OTP" },
                { label: "Subscription", value: "Subscription" },
              ]}
              onChange={(value) => {
                setFilterType(value);
              }}
              value={filterType}
            ></Select>
          </div>
        </div>
        <div
          style={{
            width: "95%",
            minWidth: "60vw",
            height: "170vh",
          }}
        >
          <PlotContainer
            tooltipTitle="Lifetime Revenue"
            useApi={useGetLtvVsCacQuery}
            useApiArgs={{
              client: selectedClient,
              type: filterType,
            }}
          />
        </div>
      </div>
    );
};

export default LtvVsCac;